import React, { useState } from "react";
import { Button, FormLabel, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import BookDetailsCard from "../../common/bookDetailsCard";
import EditBookDetails from "../editBookDetails";
import "./style.css";

function BookDetailsModal({
  openModal,
  HideModal,
  src,
  item,
  getPublisherBooks,
}) {
  const CloseModal = () => {
    HideModal();
  };
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.root.user);
  const openModal2 = () => {
    HideModal();
    setIsOpen(true);
  };
  const closeModal2 = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Modal
        size="lg"
        backdrop="static"
        show={openModal}
        onHide={HideModal}
        centered
      >
        <button
          type="button"
          className="close custom-modal-close"
          onClick={CloseModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="p-5">
          <BookDetailsCard src={src} item={item} />
          {user?.isLoggedIn && user?.user?.type === "publisher" && (
            <div className="d-flex justify-content-center">
              <Button className="custom-edit-btn mt-3" onClick={openModal2}>
                Edit Details
              </Button>
            </div>
          )}
        </div>
      </Modal>
      <EditBookDetails
        openModal={isOpen}
        HideModal={closeModal2}
        src={src}
        item={item}
        getPublisherBooks={getPublisherBooks}
      />
    </>
  );
}

export default BookDetailsModal;
